import { Dropdown } from "@almafintech/react-components";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import GlobeIcon from "../../assets/images/icons/ui/globe-outine-black.svg?react";
import { onUpdateLanguage } from "../../reducers/onboardingDataReducer";
import styles from "./LanguagePicker.module.scss";

const LanguagePicker = ({ className }: { className?: string }) => {
  const { icon } = styles;

  const state = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  return (
    <div className={className}>
      <Dropdown
        items={[
          {
            label: "🇪🇸 Español",
            key: "es",
            action: () => dispatch(onUpdateLanguage("es")),
          },
          {
            label: "🇺🇸 English",
            key: "en",
            action: () => dispatch(onUpdateLanguage("en")),
          },
        ]}
        selectedKeys={[state.onboardingData.language]}
      >
        <div className={icon}>
          <GlobeIcon />
        </div>
      </Dropdown>
    </div>
  );
};

export default LanguagePicker;
